import { List, ListItemButton, ListItemText } from "@mui/material";
import { memo, useState } from "react";
import moment from "moment";
// import AssignmentDistributionStats from "../../../../../_5Pages/4DashboardPage/DashboardParts/AddAssignmentBox/AssignmentDistributionStats";
// import WorkloadMinutesSeverityPill from "../../../../../_4GeneralHelpers/3_SeverityPills/WorkloadMinutesSeverityPill";
// import PickUpToDoButton from "../../../../../_4GeneralHelpers/2_Buttons/PickUpToDoButton";
import canEditAssignment from "../canEditAssignment";
import { useHusibuechContext } from "../../../../context/husibuechContext";
import AssignmentListItem from "./AssignmentListItem";
import WorkloadMinutesSeverityPill from "../../../../HusibuechHelpers/3_Tools/1_Pills/WorkloadMinutesSeverityPill";
import { createSubjectTag } from "../../../../helpers/nameHelpers";
// import EditAssignmentPopover from "../1_Popover/EditAssignmentPopover";

function AssignmentList({ type, assignments, classView }) {
  const { userCourses } = useHusibuechContext();
  const [setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const getAssignmentPrimaryText = (assignment) => (
    <>
      {assignment.name}
      {assignment.type !== "personal" &&
        ` (${createSubjectTag(assignment.course_name)})`}
    </>
  );

  const getAssignmentSecondaryText = (assignment) => (
    <>
      {moment(assignment.due_date).locale("de").format("dd, DD. MMM")}
      &nbsp;
      <WorkloadMinutesSeverityPill
        assignment={assignment}
        disabled={!canEditAssignment(assignment, userCourses)}
        classView={classView}
      />
      {/* {type === "personal" && <PickUpToDoButton assignment={assignment} />} */}
      {/* {type === "class" &&
        userCourses?.some((course) => course.id === assignment.course_id) && (
          <>
            &nbsp;
            <AssignmentDistributionStats assignment={assignment} />
          </>
        )} */}
    </>
  );
  return (
    <List
      dense
      sx={{
        width: "100%",
        position: "relative",
        maxHeight: { xl: 330, xs: 310 },
        "& ul": { padding: 0 },
      }}
    >
      {assignments.map((assignment, i) => (
        <div key={i}>
          <ListItemButton
            divider={i < assignments.length - 1}
            key={i}
            // style={{ marginTop: "-0.4em", paddingBottom: "-0.4" }}
            // disablePadding
            onClick={handleClick}
          >
            <AssignmentListItem
              assignment={assignment}
              classView={classView}
              sx={{
                cursor: "pointer",
              }}
            />
            <ListItemText
              primary={getAssignmentPrimaryText(assignment)}
              secondary={getAssignmentSecondaryText(assignment)}
            />
          </ListItemButton>
        </div>
      ))}
    </List>
  );
}

export default memo(AssignmentList);
